import { pickBy } from 'lodash';
import { DEFAULTS } from '../defaults.js';
export { LINK_PREVIEW_TYPE } from '../types.js';
import 'ricos-schema';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const fetchLinkPreview = async (fetchData, url) => {
  const fixedUrl = url.split("\u21B5").join("");
  const { thumbnail_url, title, description, html } = await (fetchData == null ? void 0 : fetchData(fixedUrl)) || {};
  return { thumbnailUrl: thumbnail_url, title, description, html, fixedUrl };
};
const createLinkPreviewData = async (linkData, { thumbnailUrl, title, description, html, fixedUrl }, linkPreviewConfig) => {
  const currentConfig = __spreadValues(__spreadValues({}, DEFAULTS), linkPreviewConfig).config;
  const data = {
    config: __spreadProps(__spreadValues({}, currentConfig), {
      link: __spreadProps(__spreadValues(__spreadValues({}, currentConfig.link), pickBy(linkData)), { url: fixedUrl }),
      width: html && 350
    }),
    thumbnail_url: thumbnailUrl,
    title,
    description,
    html
  };
  if (thumbnailUrl && await isValidImgSrc(thumbnailUrl)) {
    data.thumbnail_url = thumbnailUrl;
  }
  return data;
};
const isValidImgSrc = (url) => {
  return new Promise((resolve) => {
    const image = document.createElement("img");
    image.src = url;
    image.onload = () => {
      resolve(true);
    };
    image.onerror = () => {
      resolve(false);
    };
  });
};
const shouldAddLinkPreview = (title, enableLinkPreview) => enableLinkPreview && title;
const shouldAddEmbed = (html, enableEmbed, url) => {
  if (Array.isArray(enableEmbed)) {
    return enableEmbed.filter((whiteListType) => url.toLowerCase().includes(whiteListType.toLowerCase())).length > 0;
  }
  return html && enableEmbed;
};

export { createLinkPreviewData, fetchLinkPreview, shouldAddEmbed, shouldAddLinkPreview };
//# sourceMappingURL=utils.js.map
